import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import AuthWrapper from 'shared/components/auth_wrapper/AuthWrapper';
import { LoginVS } from 'shared/utils/validation/AuthValidation';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import styles from './style.module.scss';
import { classNames } from 'shared/utils/Helper';
import Heading from 'shared/components/common/heading/Heading';
import { StatsLoginImage } from 'assets';
import { useNavigate } from 'react-router-dom';
import { setUser } from 'shared/redux/reducers/UserSlice';
import { useDispatch } from 'react-redux';
import { LoginMutation } from 'shared/services/auth_service/AuthService';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { routeConstant } from 'shared/routes/RouteConstant';
const Login = () => {
    const navigate = useNavigate();
    const { mutate, isLoading, isError, isSuccess, error, data } = LoginMutation();
    const dispatch = useDispatch();
    const [rememberMe, setRememberMe] = useState(false);
    const initialValues = {
        email: '',
        password: ''
    };
    const handleLogIn = (values, action) => {
        let params = {
            password: values.password,
            email: values.email,
            type: values.email === 'admin@admin.com' ? 'admin' : 'user'
        };
        mutate(values);
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: LoginVS,
        onSubmit: (value) => {
            handleLogIn(value);
        }
    });
    const { handleChange, handleSubmit, values, touched, errors } = formik;

    
    useEffect(() => {
        if (isSuccess) {
            let dataInfo = data?.data?.data;
            let params = {
                isLoggedIn: true,
                user: dataInfo?.user,
                token: dataInfo?.token,
                type: 'admin'
            };
            dispatch(setUser(params));
        }
    }, [isSuccess]);
    const handleForgetPass = () => {
        navigate(routeConstant.forgot.path);
    };

    return (
        <AuthWrapper mainImage={StatsLoginImage} heading="“ The best features, we’re offering for the productivity ”">
            <form className={classNames(styles.LoginContainer)} >
                <Heading heading="Welcome to WISE TECH" headingStyle={classNames(styles.LoginHeading)} />
                <div className={classNames(styles.LoginMainTitle)}>Sign in to your WISE TECH account and use it for your program management</div>
                <CustomInput label="Email" placeholder="e.g, john.legend@gmail.com" value={values.email} onChange={handleChange('email')} error={errors.email && touched.email ? errors.email : ''} />
                <CustomInput
                    label="Password"
                    type="password"
                    placeholder="***********"
                    value={values.password}
                    onChange={handleChange('password')}
                    error={errors.password && touched.password ? errors.password : ''}
                />
                {/* <div className={classNames(styles.ForgotContainer)} onClick={handleForgetPass}>
                    Forget Password
                </div> */}
                <CustomButton text="Sign in" containerStyle={classNames(styles.SignInBtn)} submitHandle={handleSubmit}/>
            </form>
            {isLoading && <OverlayLoading />}
        </AuthWrapper>
    );
};

export default Login;
